import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לזהות את הדריכות",
    opening: localizedGenderNode(
      [
      "היום אני לא מנסה להרגיע בכוח.",
      "אני רק מזהה: יש בי דריכות."
    ],
      [
      "היום אני לא מנסה להרגיע בכוח.",
      "אני רק מזהה: יש בי דריכות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך הדריכות מרגישה בגוף?",
      "מתי היא הכי חזקה?",
      "איזו מחשבה ראשונה עולה?"
    ],
      [
      "איך הדריכות מרגישה בגוף?",
      "מתי היא הכי חזקה?",
      "איזו מחשבה ראשונה עולה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "דריכות היא חוויה, לא נבואה."
    ],
      [
      "דריכות היא חוויה, לא נבואה."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת + \"יש בי דריכות, ואני איתי\".",
      "נשימה אחת + \"יש בי דריכות, ואני איתי\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "הרגע הראשון",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב לרגע הראשון שהדריכות עולה.",
      "אני רק מבחין/ה."
    ],
      [
      "היום אני שם/ה לב לרגע הראשון שהדריכות עולה.",
      "אני רק מבחין/ה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי ביום זה מתחיל?",
      "מה הגוף עושה קודם?",
      "מה אני מנסה למנוע?"
    ],
      [
      "מתי ביום זה מתחיל?",
      "מה הגוף עושה קודם?",
      "מה אני מנסה למנוע?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "ברגע הראשון יש לי קצת מרחב."
    ],
      [
      "ברגע הראשון יש לי קצת מרחב."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת כשהדריכות עולה.",
      "נשימה אחת כשהדריכות עולה."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "גוף לפני מחשבה",
    opening: localizedGenderNode(
      [
      "היום אני נותן/ת לגוף מקום לפני הסיפור.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני נותן/ת לגוף מקום לפני הסיפור.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לנשימה.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לנשימה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה הדריכות יושבת בגוף?",
      "מה הגוף מנסה להגן?",
      "מה יכול להרפות קצת?"
    ],
      [
      "איפה הדריכות יושבת בגוף?",
      "מה הגוף מנסה להגן?",
      "מה יכול להרפות קצת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "הגוף מנסה לשמור עלי."
    ],
      [
      "הגוף מנסה לשמור עלי."
    ]
    ),
    action: localizedGenderNode(
      "יד על החזה ונשימה אחת.",
      "יד על החזה ונשימה אחת."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "הסיפור של האסון",
    opening: localizedGenderNode(
      [
      "היום אני מזהה את הסיפור שמספר על אסון.",
      "אני לא נלחם/ת בו."
    ],
      [
      "היום אני מזהה את הסיפור שמספר על אסון.",
      "אני לא נלחם/ת בו."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת פנימה והחוצה.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת פנימה והחוצה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה תסריט קופץ מיד?",
      "מה בו מרגיש הכי מפחיד?",
      "איזו אפשרות רכה יכולה להיות גם אמת?"
    ],
      [
      "איזה תסריט קופץ מיד?",
      "מה בו מרגיש הכי מפחיד?",
      "איזו אפשרות רכה יכולה להיות גם אמת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סיפור הוא לא עובדה."
    ],
      [
      "סיפור הוא לא עובדה."
    ]
    ),
    action: localizedGenderNode(
      "משפט פנימי - \"זה סיפור שעולה\".",
      "משפט פנימי - \"זה סיפור שעולה\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "טריגרים יומיומיים",
    opening: localizedGenderNode(
      [
      "היום אני מזהה מה מדליק את הדריכות.",
      "זה ידע, לא אשמה."
    ],
      [
      "היום אני מזהה מה מדליק את הדריכות.",
      "זה ידע, לא אשמה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מתיישב/ת עם עצמי לרגע.",
      "נשימה אחת."
    ],
      [
      "אני מתיישב/ת עם עצמי לרגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הטריגר שמדליק אותי?",
      "מתי זה חוזר?",
      "מה אני בוחר/ת/ה שם?"
    ],
      [
      "מה הטריגר שמדליק אותי?",
      "מתי זה חוזר?",
      "מה אני בוחר/ת/ה שם?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "זיהוי הוא כבר רוגע קטן."
    ],
      [
      "זיהוי הוא כבר רוגע קטן."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב מילה אחת של טריגר.",
      "לכתוב מילה אחת של טריגר."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "סריקת סכנה",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב להרגל לסרוק סכנה.",
      "אני רק מבחין/ה."
    ],
      [
      "היום אני שם/ה לב להרגל לסרוק סכנה.",
      "אני רק מבחין/ה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את כפות הרגליים.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את כפות הרגליים.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה אני מחפש/ת סימנים?",
      "מה אני חושב/ת שיגן עלי אם אזהה בזמן?",
      "מה קורה לי אחרי הסריקה?"
    ],
      [
      "איפה אני מחפש/ת סימנים?",
      "מה אני חושב/ת שיגן עלי אם אזהה בזמן?",
      "מה קורה לי אחרי הסריקה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני לא רוצה/ת לסרוק כל רגע."
    ],
      [
      "אני לא רוצה/ת לסרוק כל רגע."
    ]
    ),
    action: localizedGenderNode(
      "רגע אחד בלי לבדוק.",
      "רגע אחד בלי לבדוק."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "הצורך בביטחון",
    opening: localizedGenderNode(
      [
      "היום אני נוגע/ת בצורך בביטחון שמתחת לדריכות.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני נוגע/ת בצורך בביטחון שמתחת לדריכות.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת לאט.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני מנסה להשיג בדריכות?",
      "איזו תחושת ביטחון חסרה לי?",
      "איך זה מרגיש כשיש קצת ביטחון?"
    ],
      [
      "מה אני מנסה להשיג בדריכות?",
      "איזו תחושת ביטחון חסרה לי?",
      "איך זה מרגיש כשיש קצת ביטחון?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "מאחורי דריכות יש בקשה."
    ],
      [
      "מאחורי דריכות יש בקשה."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב בקשה אחת לעצמי.",
      "לכתוב בקשה אחת לעצמי."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "גבול פנימי",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה גבול פנימי לדריכות.",
      "בלי מלחמה."
    ],
      [
      "היום אני שם/ה גבול פנימי לדריכות.",
      "בלי מלחמה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את הכתפיים נרגעות מעט.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את הכתפיים נרגעות מעט.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה לא מתאים לי בעומס הזה?",
      "איך הגוף מסמן שזה יותר מדי?",
      "איזה משפט פנימי יכול לעצור קצת?"
    ],
      [
      "מה לא מתאים לי בעומס הזה?",
      "איך הגוף מסמן שזה יותר מדי?",
      "איזה משפט פנימי יכול לעצור קצת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "גבול פנימי מוריד עוצמה."
    ],
      [
      "גבול פנימי מוריד עוצמה."
    ]
    ),
    action: localizedGenderNode(
      "משפט שקט - \"עכשיו מספיק לי\".",
      "משפט שקט - \"עכשיו מספיק לי\"."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "פחד מתחת",
    opening: localizedGenderNode(
      [
      "היום אני פוגש/ת את הפחד שמתחת לדריכות.",
      "אני נשאר/ת איתו רגע."
    ],
      [
      "היום אני פוגש/ת את הפחד שמתחת לדריכות.",
      "אני נשאר/ת איתו רגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת אל המקום הכואב.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת אל המקום הכואב.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "ממה אני מפחד/ת שיקרה?",
      "מה הכי כואב במחשבה הזו?",
      "מה הייתי בוחר/ת/ה לשמוע עכשיו?"
    ],
      [
      "ממה אני מפחד/ת שיקרה?",
      "מה הכי כואב במחשבה הזו?",
      "מה הייתי בוחר/ת/ה לשמוע עכשיו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "פחד רוצה הגנה, לא מלחמה."
    ],
      [
      "פחד רוצה הגנה, לא מלחמה."
    ]
    ),
    action: localizedGenderNode(
      "לקרוא לפחד בשם בשקט.",
      "לקרוא לפחד בשם בשקט."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "אמון קטן",
    opening: localizedGenderNode(
      [
      "היום אני מחפש/ת נקודת אמון קטנה.",
      "לא גדולה."
    ],
      [
      "היום אני מחפש/ת נקודת אמון קטנה.",
      "לא גדולה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את האוויר נכנס ויוצא.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את האוויר נכנס ויוצא.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי בעבר הדריכות נרגעה?",
      "מה עזר אפילו מעט?",
      "על מה קטן אני יכול/ה לסמוך היום?"
    ],
      [
      "מתי בעבר הדריכות נרגעה?",
      "מה עזר אפילו מעט?",
      "על מה קטן אני יכול/ה לסמוך היום?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אמון קטן מספיק להתחלה."
    ],
      [
      "אמון קטן מספיק להתחלה."
    ]
    ),
    action: localizedGenderNode(
      "לזכור דבר אחד שעוזר.",
      "לזכור דבר אחד שעוזר."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "חזרה לגוף",
    opening: localizedGenderNode(
      [
      "היום אני חוזר/ת לגוף כשאני נסחף/ת.",
      "אני איתי."
    ],
      [
      "היום אני חוזר/ת לגוף כשאני נסחף/ת.",
      "אני איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את משקל הגוף.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את משקל הגוף.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה מחזיר אותי לנוכחות?",
      "איזו נשימה עושה לי טוב?",
      "מה אני מרגיש/ה עכשיו ממש?"
    ],
      [
      "מה מחזיר אותי לנוכחות?",
      "איזו נשימה עושה לי טוב?",
      "מה אני מרגיש/ה עכשיו ממש?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "נוכחות מקטינה את הרעש."
    ],
      [
      "נוכחות מקטינה את הרעש."
    ]
    ),
    action: localizedGenderNode(
      "נשימה איטית אחת עם יד על הבטן.",
      "נשימה איטית אחת עם יד על הבטן."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "רגע לפני דחף",
    opening: localizedGenderNode(
      [
      "היום אני נותן/ת רגע שקט לפני הדחף לבדוק.",
      "אני יכול/ה לחכות רגע."
    ],
      [
      "היום אני נותן/ת רגע שקט לפני הדחף לבדוק.",
      "אני יכול/ה לחכות רגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לרגע הזה.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לרגע הזה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הדחף הראשון שלי כשאני דרוך/ה?",
      "מה קורה אם אני מחכה רגע?",
      "מה אני מגלה אחרי ההמתנה?"
    ],
      [
      "מה הדחף הראשון שלי כשאני דרוך/ה?",
      "מה קורה אם אני מחכה רגע?",
      "מה אני מגלה אחרי ההמתנה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "רגע שקט הוא בחירה."
    ],
      [
      "רגע שקט הוא בחירה."
    ]
    ),
    action: localizedGenderNode(
      "לעצור רגע לפני בדיקה.",
      "לעצור רגע לפני בדיקה."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "צעד קטן",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת צעד קטן בתוך הדריכות.",
      "לא מהפכה."
    ],
      [
      "היום אני בוחר/ת צעד קטן בתוך הדריכות.",
      "לא מהפכה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט ומביט/ה סביבי.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת לאט ומביט/ה סביבי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה צעד קטן מרגיע אותי?",
      "מתי אני יכול/ה לעשות אותו?",
      "מה יעזור לי לזכור?"
    ],
      [
      "איזה צעד קטן מרגיע אותי?",
      "מתי אני יכול/ה לעשות אותו?",
      "מה יעזור לי לזכור?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "קטן מספיק הוא מספיק."
    ],
      [
      "קטן מספיק הוא מספיק."
    ]
    ),
    action: localizedGenderNode(
      "לבחור צעד קטן אחד.",
      "לבחור צעד קטן אחד."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "משפט חזרה",
    opening: localizedGenderNode(
      [
      "היום אני מסיים/ת עם משפט שמחזיר אותי לעצמי.",
      "אני בוחר/ת נוכחות."
    ],
      [
      "היום אני מסיים/ת עם משפט שמחזיר אותי לעצמי.",
      "אני בוחר/ת נוכחות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע לפני תגובה.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע לפני תגובה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה למדתי על הדריכות הזו?",
      "מה הסימן הראשון שהיא עולה?",
      "מה המשפט הקצר שלי?"
    ],
      [
      "מה למדתי על הדריכות הזו?",
      "מה הסימן הראשון שהיא עולה?",
      "מה המשפט הקצר שלי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני בוחר/ת רגע לפני תגובה."
    ],
      [
      "אני בוחר/ת רגע לפני תגובה."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת + המשפט שלי.",
      "נשימה אחת + המשפט שלי."
    ),
  },
].map(buildNormalizedDay);

export const anxietyVigilanceBlueprintHe = buildNormalizedPilotBlueprint({
  id: "anxiety_vigilance_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "anxiety_vigilance",
  category: "anxiety",
  journeyName: {
    he: "תחושת דריכות תמידית / אסון עוד רגע מגיע",
    en: "Constant vigilance / a disaster is about to happen",
    es: "Sensación de alerta constante / algo malo por pasar",
  },
  days,
});

export default anxietyVigilanceBlueprintHe;
